import axios from "axios";

const axiosInstanceIDM = axios.create({
  baseURL: process.env.REACT_APP_API_IDM_URL,
});

export default axiosInstanceIDM;
